<div class ="main">
    <audio autoplay loop src="./../../assets/Audios/mallbg.mp3"></audio>
    <div class ="header">
        <iframe src="https://3dwarehouse.sketchup.com/embed/ua9f23fae-3c4d-4fd9-96d8-1277b68aaa58" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="100%" allowfullscreen></iframe>
    </div>
</div>